import React from 'react'
import { SvgIcon } from '@farewill/ui'

const PinIcon = ({ color }: { color: string }): React.ReactElement => (
  <SvgIcon width="25" height="34" viewBox="0 0 25 34" title="Pin icon">
    <path
      d="M25 12.5C25 20 18.25 30.25 12.5 33.625C6.75 30.25 0 20 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5Z"
      fill={color}
    />
    <circle cx="12.626" cy="12.125" r="5.375" fill="white" />
  </SvgIcon>
)

export default PinIcon
